import React from 'react';
import { Button, ButtonTemplateProps, ButtonVariant } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';

interface BackButtonProps extends ButtonTemplateProps {}

export default function BackButton(props: BackButtonProps) {
  return <Button text={t(TranslationKey.back).singular.upper} variant={ButtonVariant.link} {...props} />;
}
